import Layout from '../views/layout/layout'
// 工作流的待办和已经办理
export default {
    path: '/workFlow',
    name: 'workFlow',
    component: Layout,
    children: [
        {
            path: '/workflow/detail',
            name: 'workFlowDetailIndex',
            component: () => import('../views/workFlow/detail/index'),
            meta: {title: '工作流历史', keepAlive: true}
        },
        {
            path: '/todoList',
            name: 'todoList',
            component: () => import('../views/workFlow/todoList/index'),
            meta: {title: '待办任务', keepAlive: true}
        },
        {
            path: '/doneList',
            name: 'doneList',
            component: () => import('../views/workFlow/doneList/index'),
            meta: {title: '已办任务', keepAlive: true}
        },
        {
            path: '/ruleDefinition',
            name: 'ruleDefinition',
            component: () => import('../views/workFlow/rule/index'),
            meta: {title: '规则配置', keepAlive: true}
        },
        {
            path: '/allList',
            name: 'allList',
            component: () => import('../views/workFlow/allList/index'),
            meta: {title: '全部任务', keepAlive: true}
        },
        {
            path: '/projAssessmentRule',
            name: 'projAssessmentRule',
            component: () => import('../views/workFlow/rule/childRule/projAssessmentRule'),
            meta: {title: '项目考核利润规则详情'}
        },
        {
            path: '/projCheckRule',
            name: 'projCheckRule',
            component: () => import('../views/workFlow/rule/childRule/projCheckRule'),
            meta: {title: '协议通过规则详情'}
        },
        {
            path: '/workerCostApplyRule',
            name: 'workerCostApplyRule',
            component: () => import('../views/workFlow/rule/childRule/workerCostApplyRule'),
            meta: {title: '工费审批规则详情'}
        },
        {
            path: '/expectedDeliveryRule',
            name: 'expectedDeliveryRule',
            component: () => import('../views/workFlow/rule/childRule/expectedDeliveryRule'),
            meta: {title: '计划交房日期规则详情'}
        },
        {
            path: '/materialContractRule',
            name: 'materialContractRule',
            component: () => import('../views/workFlow/rule/childRule/materialContractRule'),
            meta: {title: '材料合同供应商规则详情'}
        },
        {
            path: '/financeTransferCw01Rule',
            name: 'financeTransferCw01Rule',
            component: () => import('../views/workFlow/rule/childRule/financeTransferCw01'),
            meta: {title: '客户转款审批流程_财务审批（设计意向金）'}
        },
        {
            path: '/financeTransferGyljlRule',
            name: 'financeTransferGyljlRule',
            component: () => import('../views/workFlow/rule/childRule/financeTransferGyljl'),
            meta: {title: '客户转款审批流程_供应链经理审批'}
        },
        {
            path: '/financeTransferGcjlRule',
            name: 'financeTransferGcjlRule',
            component: () => import('../views/workFlow/rule/childRule/financeTransferGcjl'),
            meta: {title: '客户转款审批流程_工程经理审批'}
        },
        {
            path: '/financeTransferCw02Rule',
            name: 'financeTransferCw02Rule',
            component: () => import('../views/workFlow/rule/childRule/financeTransferCw02'),
            meta: {title: '客户转款审批流程_财务审批'}
        },
        {
            path: '/financeTransferFenzongRule',
            name: 'financeTransferFenzongRule',
            component: () => import('../views/workFlow/rule/childRule/financeTransferFenzongRule'),
            meta: {title: '客户转款审批流程_分总'}
        },
        {
            path: '/financeCustomerFlow02Rule',
            name: 'financeCustomerFlow02Rule',
            component: () => import('../views/workFlow/rule/childRule/financeCustomer'),
            meta: {title: '客户收款-财务审批'}
        },
        {
            path: '/financeBusinessConfirm01Rule',
            name: 'financeBusinessConfirm01Rule',
            component: () => import('../views/workFlow/rule/childRule/financeBusinessConfirm01'),
            meta: {title: '商家收款供应链经理审批'}
        },
        {
            path: '/profitSplitRule',
            name: 'profitSplitRule',
            component: () => import('../views/workFlow/rule/childRule/profitSplitRule'),
            meta: {title: '派单表审批'}
        },
        {
            path: '/resetAccountsSettleRule',
            name: 'resetAccountsSettleRule',
            component: () => import('../views/workFlow/rule/childRule/resetAccountsSettleRule'),
            meta: {title: '结核算重置审批'}
        },
        {
            path: '/shopInfoAuditRuleFlow01',
            name: 'shopInfoAuditRuleFlow01',
            component: () => import('../views/workFlow/rule/childRule/shopInfoAuditRuleFlow01'),
            meta: {title: '店铺管理分总审批'}
        },
        {
            path: '/shopInfoAuditRuleFlow02',
            name: 'shopInfoAuditRuleFlow02',
            component: () => import('../views/workFlow/rule/childRule/shopInfoAuditRuleFlow02'),
            meta: {title: '店铺管理总监审批'}
        },
        {
            path: '/shopInfoAuditRuleFlow03',
            name: 'shopInfoAuditRuleFlow03',
            component: () => import('../views/workFlow/rule/childRule/shopInfoAuditRuleFlow03'),
            meta: {title: '店铺管理软装分总审批'}
        },
        {
            path: '/shopInfoAuditRuleProduct',
            name: 'shopInfoAuditRuleProduct',
            component: () => import('../views/workFlow/rule/childRule/shopInfoAuditRuleProduct'),
            meta: {title: '店铺管理产品经理审批'}
        },
        {
            path: '/shopInfoAuditRuleLegalAffairs',
            name: 'shopInfoAuditRuleLegalAffairs',
            component: () => import('../views/workFlow/rule/childRule/shopInfoAuditRuleLegalAffairs'),
            meta: {title: '店铺管理法务审批'}
        },
        {
            path: '/supplyInfoAuditRuleFlow01',
            name: 'supplyInfoAuditRuleFlow01',
            component: () => import('../views/workFlow/rule/childRule/supplyInfoAuditRuleFlow01'),
            meta: {title: '供应商管理分总审批'}
        },
        {
            path: '/supplyInfoApplyRuleFlow01',
            name: 'supplyInfoApplyRuleFlow01',
            component: () => import('../views/workFlow/rule/childRule/supplyInfoApplyRuleFlow01'),
            meta: {title: '供应商电子签申请池审批流程'}
        },
        {
            path: '/supplyInfoAuditRuleFlow02',
            name: 'supplyInfoAuditRuleFlow02',
            component: () => import('../views/workFlow/rule/childRule/supplyInfoAuditRuleFlow02'),
            meta: {title: '供应商管理总监审批'}
        },
        {
            path: '/supplyInfoAuditRuleLegalAffairs',
            name: 'supplyInfoAuditRuleLegalAffairs',
            component: () => import('../views/workFlow/rule/childRule/supplyInfoAuditRuleLegalAffairs'),
            meta: {title: '供应商管理法务审批'}
        },
        {
            path: '/supplyInfoAuditRuleProduct',
            name: 'supplyInfoAuditRuleProduct',
            component: () => import('../views/workFlow/rule/childRule/supplyInfoAuditRuleProduct'),
            meta: {title: '供应商管理产品经理审批'}
        },
        {
            path: '/outsourceCivilRule',
            name: 'outsourceCivilRule',
            component: () => import('../views/workFlow/rule/childRule/outsourceCivilRule'),
            meta: {title: '外包拆改建审批'}
        },
        {
            path: '/busiCustomerOrderRule',
            name: 'busiCustomerOrderRule',
            component: () => import('../views/workFlow/rule/childRule/busiCustomerOrder'),
            meta: {title: '客户资源申请分派_销售总监分派客户资源'}
        },
        {
            path: '/backOrderRule',
            name: 'backOrderRule',
            component: () => import('../views/workFlow/rule/childRule/backOrderRule'),
            meta: {title: '退货单规则详情'}
        },
        {
            path: '/purchaseOrderRule',
            name: 'purchaseOrderRule',
            component: () => import('../views/workFlow/rule/childRule/purchaseOrderRule'),
            meta: {title: '采购单规则详情'}
        },
        {
            path: '/sendOrderRule',
            name: 'sendOrderRule',
            component: () => import('../views/workFlow/rule/childRule/sendOrderRule'),
            meta: {title: '送货单规则详情'}
        },
        {
            path: '/returnOrderRule',
            name: 'returnOrderRule',
            component: () => import('../views/workFlow/rule/childRule/returnOrderRule'),
            meta: {title: '返利单规则详情'}
        },
        {
            path: '/saleOrderRule',
            name: 'saleOrderRule',
            component: () => import('../views/workFlow/rule/childRule/saleOrderRule'),
            meta: {title: '销售单规则详情'}
        },
        {
            path: '/discountOrderRule',
            name: 'discountOrderRule',
            component: () => import('../views/workFlow/rule/childRule/discountOrderRule'),
            meta: {title: '优惠单规则详情'}
        },
        {
            path: '/bizContractSoftDesignRule',
            name: 'bizContractSoftDesignRule',
            component: () => import('../views/workFlow/rule/childRule/bizContractSoftDesignRule'),
            meta: {title: '软装设计合同规则详情'}
        },
        {
            path: '/bizNodePostponeRule',
            name: 'bizNodePostponeRule',
            component: () => import('../views/workFlow/rule/childRule/bizNodePostponeRule'),
            meta: {title: '八部九式延期规则详情'}
        },
        {
            path: '/bizNodeRestartRule',
            name: 'bizNodeRestartRule',
            component: () => import('../views/workFlow/rule/childRule/bizNodeRestartRule'),
            meta: {title: '八部九式再执行规则详情'}
        },
        {
            path: '/supplierSettlementRule',
            name: 'supplierSettlementRule',
            component: () => import('../views/workFlow/rule/childRule/supplierSettlementRule'),
            meta: {title: '商家结算规则详情'}
        },
        {
            path: '/projectManagerRule',
            name: 'projectManagerRule',
            component: () => import('../views/workFlow/rule/childRule/projectManagerRule'),
            meta: {title: '项目经理结算规则详情'}
        },
        {
            path: '/projectManagerResetRule',
            name: 'projectManagerResetRule',
            component: () => import('../views/workFlow/rule/childRule/projectManagerResetRule'),
            meta: {title: '项目经理结算重置规则详情'}
        },
        {
            path: '/customerMaterialReportRule',
            name: 'customerMaterialReportRule',
            component: () => import('../views/workFlow/rule/childRule/customerMaterialReportRule'),
            meta: {title: '客户材料结算规则详情'}
        },
        {
            path: '/projectStartWorkAuditRule',
            name: 'projectStartWorkAuditRule',
            component: () => import('../views/workFlow/rule/childRule/projectStartWorkAuditRule'),
            meta: {title: '规则详情'}
        },
        {
            path: '/projectPaymentRule',
            name: 'projectPaymentRule',
            component: () => import('../views/workFlow/rule/childRule/projectPaymentRule'),
            meta: {title: '项目付款规则详情'}
        },
        {
            path: '/projectPaymentPersonRule',
            name: 'projectPaymentPersonRule',
            component: () => import('../views/workFlow/rule/childRule/projectPaymentPersonRule'),
            meta: {title: '项目人工费付款规则详情'}
        },
        {
            path: '/customerWorkOrderRule',
            name: 'customerWorkOrderRule',
            component: () => import('../views/workFlow/rule/childRule/customerWorkOrderRule'),
            meta: {title: '工单审核规则详情'}
        },
        {
            path: '/contractBaseRule',
            name: 'contractBaseRule',
            component: () => import('../views/workFlow/rule/childRule/contractBaseRule'),
            meta: {title: '基装合同财务审核规则详情'}
        },
        {
            path: '/bizOrderServiceStopRule',
            name: 'bizOrderServiceStopRule',
            component: () => import('../views/workFlow/rule/childRule/bizOrderServiceStopRule'),
            meta: {title: '服务单终止审核规则详情'}
        },
        {
            path: '/contractDesignRule',
            name: 'contractDesignRule',
            component: () => import('../views/workFlow/rule/childRule/contractDesignRule'),
            meta: {title: '设计合同财务审核规则详情'}
        },
        {
            path: '/contractReformRule',
            name: 'contractReformRule',
            component: () => import('../views/workFlow/rule/childRule/contractReformRule'),
            meta: {title: '拆改建合同财务审核规则详情'}
        },
        {
            path: '/materialPaymentOrderRule',
            name: 'materialPaymentOrderRule',
            component: () => import('../views/workFlow/rule/childRule/materialPaymentOrderRule'),
            meta: {title: '打款单审核规则详情'}
        },
        {
            path: '/reformRebateRule',
            name: 'reformRebateRule',
            component: () => import('../views/workFlow/rule/childRule/reformRebateRule'),
            meta: {title: '拆改建返利订单审核规则详情'}
        },
        {
            path: '/reformRebateRefundRule',
            name: 'reformRebateRefundRule',
            component: () => import('../views/workFlow/rule/childRule/reformRebateRefundRule'),
            meta: {title: '拆改建返利收退款审核规则详情'}
        },
        {
            path: '/contractReformResignRule',
            name: 'contractReformResignRule',
            component: () => import('../views/workFlow/rule/childRule/contractReformResignRule'),
            meta: {title: '拆改建合同重签审核规则详情'}
        },
        {
            path: '/contractDesignResignRule',
            name: 'contractDesignResignRule',
            component: () => import('../views/workFlow/rule/childRule/contractDesignResignRule'),
            meta: {title: '设计合同重签审核规则详情'}
        },
        {
            path: '/contractBaseResignRule',
            name: 'contractBaseResignRule',
            component: () => import('../views/workFlow/rule/childRule/contractBaseResignRule'),
            meta: {title: '基装合同重签审核规则详情'}
        },
        {
            path: '/targetCompanyRule',
            name: 'targetCompanyRule',
            component: () => import('../views/workFlow/rule/childRule/targetCompanyRule'),
            meta: {title: '项目目标分公司数据审核规则详情'}
        },
        {
            path: '/projectPaymentOtherRule',
            name: 'projectPaymentOtherRule',
            component: () => import('../views/workFlow/rule/childRule/projectPaymentOtherRule'),
            meta: {title: '项目费用付款规则详情'}
        },
        {
            path: '/projectPaymentManagerRule',
            name: 'projectPaymentManagerRule',
            component: () => import('../views/workFlow/rule/childRule/projectPaymentManagerRule'),
            meta: {title: '项目经理付款规则详情'}
        },
        {
            path: '/materialPaymentRule',
            name: 'materialPaymentRule',
            component: () => import('../views/workFlow/rule/childRule/materialPaymentRule'),
            meta: {title: '材料付款规则详情'}
        },
        {
            path: '/bizNeededStuffOrderRule',
            name: 'bizNeededStuffOrderRule',
            component: () => import('../views/workFlow/rule/childRule/bizNeededStuffOrderRule'),
            meta: {title: '必选大类跑单规则详情'}
        },
        {
            path: '/bizContractTerminationRule',
            name: 'bizContractTerminationRule',
            component: () => import('../views/workFlow/rule/childRule/bizContractTerminationRule'),
            meta: {title: '协议终止规则详情'}
        },
        {
            path: '/materialContractFzRule',
            name: 'materialContractFzRule',
            component: () => import('../views/workFlow/rule/childRule/materialContractFzRule'),
            meta: {title: '材料合同副总规则详情'}
        },
        {
            path: '/bizElectronicReceiptRule',
            name: 'bizElectronicReceiptRule',
            component: () => import('../views/workFlow/rule/childRule/bizElectronicReceiptRule'),
            meta: {title: '电子收据审核规则详情'}
        },

        {
            path: '/projSpecialApproveRule',
            name: 'projSpecialApproveRule',
            component: () => import('../views/workFlow/rule/childRule/projSpecialApproveRule'),
            meta: {title: '特批特殊审批规则详情'}
        },





    ]
}
